import React, { useId } from 'react';
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';

export const FOOTAGE_FOLDER_TAG_OPTIONS = [
  { value: 'ai-story', label: 'AI Story' },
  { value: 'sleep-channel', label: 'Sleep Channel' },
];

const NONE_VALUE = '__none__';

export function footageFolderTagLabel(tag) {
  return FOOTAGE_FOLDER_TAG_OPTIONS.find((option) => option.value === tag)?.label || tag;
}

export default function FootageFolderTagsSelect({
  value = [],
  onChange,
  disabled = false,
  margin = 'dense',
  sx,
}) {
  const labelId = useId();
  const selected = Array.isArray(value) ? value : [];

  return (
    <FormControl fullWidth margin={margin} disabled={disabled} sx={sx}>
      <InputLabel id={labelId} shrink>
        Used for
      </InputLabel>
      <Select
        labelId={labelId}
        multiple
        displayEmpty
        label='Used for'
        value={selected}
        onChange={(event) => {
          const next = event.target.value;
          onChange(next.includes(NONE_VALUE) ? [] : next);
        }}
        renderValue={(tags) =>
          tags.length ? tags.map(footageFolderTagLabel).join(', ') : 'None'
        }
      >
        <MenuItem value={NONE_VALUE}>
          <Checkbox checked={selected.length === 0} />
          <ListItemText primary='None' />
        </MenuItem>
        {FOOTAGE_FOLDER_TAG_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={selected.includes(option.value)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
